import { useQuery } from "@tanstack/react-query";
import { useAuth, authorizedAxios } from "@moonscape/shared";

/**
 * Lightweight hook to check if user has any transactions.
 * Used to conditionally hide portfolio widgets when user has transactions
 * but no current balances (e.g., CSV imports of sold positions).
 */
export const useHasTransactions = () => {
  const { user, getToken } = useAuth();
  const email = user?.email;

  const checkHasTransactions = async () => {
    try {
      const token = await getToken();
      // Fetch just first page to check existence
      const res = await authorizedAxios(token).get('/trades?cursor=0');
      // /trades responds { items, cursor, remaining } — not { trades }
      const hasTxns = (res.data?.items?.length || 0) > 0;
      console.log("🔍 useHasTransactions - has transactions:", hasTxns);
      return hasTxns;
    } catch (error) {
      console.error("[useHasTransactions] error ", error);
      return false; // Default to false on error
    }
  };

  return useQuery({
    queryKey: ['hasTransactions'],
    queryFn: checkHasTransactions,
    enabled: !!email,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
};
